import React, { Component } from 'react';
import PropTypes from 'prop-types'; // ES6
import { Select } from 'antd';
import PopoverError from '../commons/popoverError';
import { ordenarAlfabeticamentPerAtributNom } from '../../commons/ordenacio';
const Option = Select.Option;

class AvisIntroduccioSeccioDadesVigilant extends Component {

    componentDidMount() {
        const { vigilants } = this.props;
        if (!vigilants || vigilants.length === 0) {
            const { usuariObtenirTots } = this.props;
            usuariObtenirTots();
        }
    }

    obtenirNomComplet(nom, cognom1, cognom2) {
        let nomComplet = '';
        nomComplet = nom ? nomComplet += nom : nomComplet;
        nomComplet = cognom1 ? nomComplet += ' ' + cognom1 : nomComplet;
        nomComplet = cognom2 ? nomComplet += ' ' + cognom2 : nomComplet;
        return nomComplet;
    }

    filtrarOrdenarVigilants(vigilants) {
        return vigilants
            .filter((vigilant) => {
                return vigilant.esActiu;
            })
            .map((vigilant) => {
                const { id, nom, cognom1, cognom2 } = vigilant;
                return {
                    id,
                    nom: this.obtenirNomComplet(nom, cognom1, cognom2)
                };
            })
            .sort(ordenarAlfabeticamentPerAtributNom);
    }

    renderLlistaDeVigilants(vigilants) {
        const vigilantsOrdenats = this.filtrarOrdenarVigilants(vigilants);

        return vigilantsOrdenats.map((vigilant) => {
            return <Option key={vigilant.id + ''} value={vigilant.id} >{vigilant.nom}</Option>;
        });
    }

    render() {
        const { vigilants, idVigilant, errorVigilant } = this.props;
        const { avisIntroduccioModificarVigilant } = this.props;

        if (!vigilants || vigilants.length === 0) {
            return null;
        }

        return (
            <div className="avis-introduccio-vigilant">
                <span className="titol">
                    Vigilant:
                </span>
                <span className="nom">
                    <Select
                        notFoundContent='Vigilants no carregats.'
                        className='avis-introduccio-vigilant-selector'
                        placeholder='Selecciona vigilant'
                        showSearch
                        value={idVigilant}
                        optionFilterProp='children'
                        onChange={(idVigilant) => avisIntroduccioModificarVigilant(idVigilant)}>
                        {this.renderLlistaDeVigilants(vigilants)}
                    </Select>
                    {errorVigilant ? <PopoverError /> : null}
                </span>
            </div>
        );
    }
}

AvisIntroduccioSeccioDadesVigilant.propTypes = {
    idVigilant: PropTypes.number,
    errorVigilant: PropTypes.bool,
    vigilants: PropTypes.array,
    avisIntroduccioModificarVigilant: PropTypes.func,
    usuariObtenirTots: PropTypes.func
};

export default AvisIntroduccioSeccioDadesVigilant;



// WEBPACK FOOTER //
// ./src/components/avis/avisIntroduccioSeccioDadesVigilant.js